import { useMemo } from "react"
import { useIntl } from "react-intl"
import type { MessageDescriptor } from "react-intl"
import { Select, Skeleton } from "src/components"
import { useConfig } from "src/hooks"
import { inventoryListFilterMessages } from "./inventoryListFilter.messages"

interface InventoryListFiltersSkeletonProps {
	hasLocationFilter: boolean
}

export const InventoryListFiltersSkeleton = ({ hasLocationFilter }: InventoryListFiltersSkeletonProps) => {
	const { formatMessage } = useIntl()
	const { firstRegistrationDateAvailable } = useConfig()

	const filterHeadings = useMemo<MessageDescriptor[]>(
		() => [
			...(hasLocationFilter ? [inventoryListFilterMessages.location] : []),
			inventoryListFilterMessages.condition,
			inventoryListFilterMessages.modelSeries,
			inventoryListFilterMessages.salesStatus,
			inventoryListFilterMessages.stockStatus,
			inventoryListFilterMessages.listingVisibility,
			inventoryListFilterMessages.listingQuality,
			inventoryListFilterMessages.modelVariants,
			inventoryListFilterMessages.modelGenerations,
			inventoryListFilterMessages.bodyType,
			inventoryListFilterMessages.engineAndTransmission,
			inventoryListFilterMessages.equipment,
			inventoryListFilterMessages.exteriorColor,
			inventoryListFilterMessages.interiorColor,
			inventoryListFilterMessages.price,
			inventoryListFilterMessages.mileage,
			firstRegistrationDateAvailable
				? inventoryListFilterMessages.firstRegistration
				: inventoryListFilterMessages.year,
			inventoryListFilterMessages.previousOwners,
			inventoryListFilterMessages.onlineOrderableStatus,
		],
		[firstRegistrationDateAvailable, hasLocationFilter],
	)

	return filterHeadings.map((heading, i) => {
		const isOpen = heading === inventoryListFilterMessages.modelSeries
		return (
			<Skeleton.Accordion key={i} heading={heading} open={isOpen} withBorder>
				{isOpen && (
					<Select
						options={[]}
						name="modelSeries"
						emptyLabel={formatMessage(inventoryListFilterMessages.modelSeriesAllModels)}
						emptyValue=""
					/>
				)}
			</Skeleton.Accordion>
		)
	})
}
